import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { exportReportCsv, fetchReportCatalog, runReport } from "./reports.api";
import { keys } from "./keys";

export const useReportsCatalogQuery = () => {
    return useQuery({
        queryKey: keys.reports.catalog(),
        queryFn: fetchReportCatalog,
        placeholderData: (prev) => prev
    });
};

export const useRunReport = (successCallback = null, errorCallback = null) => {
    const qc = useQueryClient();

    return useMutation({
        mutationFn: runReport,
        onSuccess: (data, variables) => {
            qc.setQueryData(keys.reports.result(variables.reportId, variables.parameters), data);

            if (successCallback) {
                successCallback(data);
            }
        },
        onError: (error) => {
            if (errorCallback) {
                errorCallback(error);
            }
        }
    });
};

export const useExportReportCsv = (successCallback = null, errorCallback = null) => {
    return useMutation({
        mutationFn: exportReportCsv,
        onSuccess: (data, variables) => {
            if (successCallback) {
                successCallback(data, variables);
            }
        },
        onError: (error) => {
            if (errorCallback) {
                errorCallback(error);
            }
        }
    });
};
